import React from 'react';

import { theme } from '../../../themeBase';
import { BodyText, Column, Row } from '../../atoms';
import Tag from '../../molecules/Tag';
import { TagColor } from '../Tag';

import { ContentWrapper, Price, Title } from './SubscriptionHeader.styles';

export type SubscriptionHeaderProps = {
  /**
   * Title
   */
  title: string;
  /**
   * Price
   */
  price?: {
    color: string;
    label: string;
  };
  /**
   * Status tag
   */
  tag?: {
    color: TagColor;
    label: string;
  };
  /**
   * Children nodes rendered in last column
   */
  children?: React.ReactNode;
  /**
   * Billing interval
   */
  interval?: string;
};

export const SubscriptionHeader = ({
  title,
  tag,
  children,
  price,
  interval,
}: SubscriptionHeaderProps) => (
  <Row rowGap={0}>
    <Column span={[12, 12, 7]}>
      <Title>
        <BodyText variant="body1" overflow="truncate">
          {title}
        </BodyText>
      </Title>
    </Column>
    <Column span={[12, 12, 11]}>
      <ContentWrapper
        gridGap={8}
        justifyContent={['flex-end', 'flex-end', 'unset']}
      >
        {tag && (
          <Tag
            color={tag.color}
            size="regular"
            label={tag.label}
            overflow="truncate"
            maxWidth={170}
          />
        )}
        {price && (
          <Price display={['none', 'none', 'flex']} gridGap={2}>
            <BodyText
              variant="body1"
              fontWeight={theme.fontWeights[3]}
              color={price.color}
            >
              {price.label}
            </BodyText>
            <BodyText variant="body2" color="gray.dark">
              ({interval})
            </BodyText>
          </Price>
        )}
      </ContentWrapper>
    </Column>
    <Column span={[0, 0, 6]} display={['none', 'none', 'block']}>
      {children}
    </Column>
  </Row>
);

export default SubscriptionHeader;
